import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageService } from 'src/app/services/auth/storage.service';
import { environment } from 'src/environments/environment';

interface ResponseB4A<T> {
  result: T;
}

export interface ShopAntifraudLimitOrders {
  cpf: number;
  email: number;
  phone: number;
  zip: number | null;
  card: number;
}

export interface ShopAntifraudConfig {
  enabled: boolean;
  day: {
    subscriber: ShopAntifraudLimitOrders;
    nonSubscriber: ShopAntifraudLimitOrders;
  };
  week: {
    subscriber: ShopAntifraudLimitOrders;
    nonSubscriber: ShopAntifraudLimitOrders;
  };
  blockedAttemptsDay: {
    subscriber: number;
    nonSubscriber: number;
  };
}

export interface ShopAntifraudConfigResponse {
  id?: string;
  antifraude?: ShopAntifraudConfig | null;
  fallbackDefaults?: ShopAntifraudConfig;
  source?: 'config' | 'missing' | 'invalid';
  reason?: string;
  auditPersisted?: boolean;
}

export interface ShopAntifraudConfigLog {
  logId?: number;
  shopConfigsId?: string;
  oldAntifraud?: string;
  newAntifraud?: string;
  reason?: string;
  userId?: number;
  dateCreated?: string;
}

@Injectable({ providedIn: 'root' })
export class ShopAntifraudConfigService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/shop-configs`;

  getConfig(): Observable<ShopAntifraudConfigResponse> {
    return this.http
      .get<ResponseB4A<ShopAntifraudConfigResponse>>(
        `${this.baseUrl}/antifraud`,
        { headers: this.authHeaders() }
      )
      .pipe(map((response) => response.result ?? {}));
  }

  updateConfig(
    antifraude: ShopAntifraudConfig,
    reason: string
  ): Observable<ShopAntifraudConfigResponse> {
    return this.http
      .put<ResponseB4A<ShopAntifraudConfigResponse>>(
        `${this.baseUrl}/antifraud`,
        { antifraude, reason },
        { headers: this.authHeaders() }
      )
      .pipe(map((response) => response.result ?? {}));
  }

  getLogs(): Observable<ShopAntifraudConfigLog[]> {
    return this.http
      .get<ResponseB4A<ShopAntifraudConfigLog[]>>(
        `${this.baseUrl}/antifraud/logs`,
        { headers: this.authHeaders() }
      )
      .pipe(map((response) => response.result ?? []));
  }

  private authHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    if (StorageService.userLogged && StorageService.token) {
      return headers.set('Authorization', `Bearer ${StorageService.token}`);
    }
    return headers;
  }
}
